var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _vm.product.LabelSettings
            ? _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-labels")))]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  label: _vm.$ct("is-one-label-product"),
                                },
                                model: {
                                  value:
                                    _vm.product.LabelSettings.IsOneLabelProduct,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.product.LabelSettings,
                                      "IsOneLabelProduct",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "product.LabelSettings.IsOneLabelProduct",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("app-product-edit-labels-stock-location", {
                        attrs: {
                          "layout-id":
                            _vm.product.LabelSettings
                              .ToUseLabelLayoutForLocation1,
                          product: _vm.product,
                          "location-id": 1,
                        },
                        on: {
                          "update:layoutId": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation1",
                              $event
                            )
                          },
                          "update:layout-id": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation1",
                              $event
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.product.LabelSettings.ToPrintForStockLocation1,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.product.LabelSettings,
                              "ToPrintForStockLocation1",
                              $$v
                            )
                          },
                          expression:
                            "product.LabelSettings.ToPrintForStockLocation1",
                        },
                      }),
                      _c("app-product-edit-labels-stock-location", {
                        attrs: {
                          "layout-id":
                            _vm.product.LabelSettings
                              .ToUseLabelLayoutForLocation2,
                          product: _vm.product,
                          "location-id": 2,
                        },
                        on: {
                          "update:layoutId": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation2",
                              $event
                            )
                          },
                          "update:layout-id": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation2",
                              $event
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.product.LabelSettings.ToPrintForStockLocation2,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.product.LabelSettings,
                              "ToPrintForStockLocation2",
                              $$v
                            )
                          },
                          expression:
                            "product.LabelSettings.ToPrintForStockLocation2",
                        },
                      }),
                      _c("app-product-edit-labels-stock-location", {
                        attrs: {
                          "layout-id":
                            _vm.product.LabelSettings
                              .ToUseLabelLayoutForLocation3,
                          product: _vm.product,
                          "location-id": 3,
                        },
                        on: {
                          "update:layoutId": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation3",
                              $event
                            )
                          },
                          "update:layout-id": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation3",
                              $event
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.product.LabelSettings.ToPrintForStockLocation3,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.product.LabelSettings,
                              "ToPrintForStockLocation3",
                              $$v
                            )
                          },
                          expression:
                            "product.LabelSettings.ToPrintForStockLocation3",
                        },
                      }),
                      _c("app-product-edit-labels-stock-location", {
                        attrs: {
                          "layout-id":
                            _vm.product.LabelSettings
                              .ToUseLabelLayoutForLocation4,
                          product: _vm.product,
                          "location-id": 4,
                        },
                        on: {
                          "update:layoutId": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation4",
                              $event
                            )
                          },
                          "update:layout-id": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation4",
                              $event
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.product.LabelSettings.ToPrintForStockLocation4,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.product.LabelSettings,
                              "ToPrintForStockLocation4",
                              $$v
                            )
                          },
                          expression:
                            "product.LabelSettings.ToPrintForStockLocation4",
                        },
                      }),
                      _c("app-product-edit-labels-stock-location", {
                        attrs: {
                          "layout-id":
                            _vm.product.LabelSettings
                              .ToUseLabelLayoutForLocation5,
                          product: _vm.product,
                          "location-id": 5,
                        },
                        on: {
                          "update:layoutId": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation5",
                              $event
                            )
                          },
                          "update:layout-id": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation5",
                              $event
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.product.LabelSettings.ToPrintForStockLocation5,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.product.LabelSettings,
                              "ToPrintForStockLocation5",
                              $$v
                            )
                          },
                          expression:
                            "product.LabelSettings.ToPrintForStockLocation5",
                        },
                      }),
                      _c("app-product-edit-labels-stock-location", {
                        attrs: {
                          "layout-id":
                            _vm.product.LabelSettings
                              .ToUseLabelLayoutForLocation6,
                          product: _vm.product,
                          "location-id": 6,
                        },
                        on: {
                          "update:layoutId": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation6",
                              $event
                            )
                          },
                          "update:layout-id": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation6",
                              $event
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.product.LabelSettings.ToPrintForStockLocation6,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.product.LabelSettings,
                              "ToPrintForStockLocation6",
                              $$v
                            )
                          },
                          expression:
                            "product.LabelSettings.ToPrintForStockLocation6",
                        },
                      }),
                      _c("app-product-edit-labels-stock-location", {
                        attrs: {
                          "layout-id":
                            _vm.product.LabelSettings
                              .ToUseLabelLayoutForLocation7,
                          product: _vm.product,
                          "location-id": 7,
                        },
                        on: {
                          "update:layoutId": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation7",
                              $event
                            )
                          },
                          "update:layout-id": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation7",
                              $event
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.product.LabelSettings.ToPrintForStockLocation7,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.product.LabelSettings,
                              "ToPrintForStockLocation7",
                              $$v
                            )
                          },
                          expression:
                            "product.LabelSettings.ToPrintForStockLocation7",
                        },
                      }),
                      _c("app-product-edit-labels-stock-location", {
                        attrs: {
                          "layout-id":
                            _vm.product.LabelSettings
                              .ToUseLabelLayoutForLocation8,
                          product: _vm.product,
                          "location-id": 8,
                        },
                        on: {
                          "update:layoutId": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation8",
                              $event
                            )
                          },
                          "update:layout-id": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation8",
                              $event
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.product.LabelSettings.ToPrintForStockLocation8,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.product.LabelSettings,
                              "ToPrintForStockLocation8",
                              $$v
                            )
                          },
                          expression:
                            "product.LabelSettings.ToPrintForStockLocation8",
                        },
                      }),
                      _c("app-product-edit-labels-stock-location", {
                        attrs: {
                          "layout-id":
                            _vm.product.LabelSettings
                              .ToUseLabelLayoutForLocation9,
                          product: _vm.product,
                          "location-id": 9,
                        },
                        on: {
                          "update:layoutId": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation9",
                              $event
                            )
                          },
                          "update:layout-id": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation9",
                              $event
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.product.LabelSettings.ToPrintForStockLocation9,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.product.LabelSettings,
                              "ToPrintForStockLocation9",
                              $$v
                            )
                          },
                          expression:
                            "product.LabelSettings.ToPrintForStockLocation9",
                        },
                      }),
                      _c("app-product-edit-labels-stock-location", {
                        attrs: {
                          "layout-id":
                            _vm.product.LabelSettings
                              .ToUseLabelLayoutForLocation10,
                          product: _vm.product,
                          "location-id": 10,
                        },
                        on: {
                          "update:layoutId": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation10",
                              $event
                            )
                          },
                          "update:layout-id": function ($event) {
                            return _vm.$set(
                              _vm.product.LabelSettings,
                              "ToUseLabelLayoutForLocation10",
                              $event
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.product.LabelSettings.ToPrintForStockLocation10,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.product.LabelSettings,
                              "ToPrintForStockLocation10",
                              $$v
                            )
                          },
                          expression:
                            "product.LabelSettings.ToPrintForStockLocation10",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }